import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import { MAINTENANCE_MODE, isMaintenanceAllowed } from '../config/maintenanceAccess'

export const LATEST_POLICY_VERSION = 'June 16, 2025'

const ADMIN_ROLE = process.env.REACT_APP_ADMIN_ROLE_NAME || 'admin'
const SUPERADMIN_ROLE = process.env.REACT_APP_SUPERADMIN_ROLE_NAME || 'superadmin'

const ProtectedRoute = () => {
  const {
    isAuthenticated,
    loading,
    user,
    privacyStatus,
    checkingPrivacy,
    maintenanceRestricted,
  } = useAuthContext()
  const location = useLocation()
  const pathname = location.pathname

  if (loading || checkingPrivacy) {
    return <div className="app-loading-fullscreen">Verifica sessione...</div>
  }

  if (maintenanceRestricted && pathname !== '/maintenance') {
    return <Navigate to="/maintenance" replace />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (MAINTENANCE_MODE) {
    const isAllowedUser = isMaintenanceAllowed(user)

    if (!isAllowedUser && pathname !== '/maintenance') {
      return <Navigate to="/maintenance" replace />
    }
    if (isAllowedUser && pathname === '/maintenance') {
      return <Navigate to="/chat" replace />
    }
  }

  // Privacy Check
  const hasAgreedPrivacy =
    privacyStatus?.agreed && privacyStatus?.version === LATEST_POLICY_VERSION

  if (!hasAgreedPrivacy && pathname !== '/privacy-consent') {
    return <Navigate to="/privacy-consent" replace />
  }

  if (hasAgreedPrivacy && pathname === '/privacy-consent') {
    return <Navigate to="/chat" replace />
  }

  // Role Checks
  const roles = user?.roles
  const isAdminUser = roles?.includes(ADMIN_ROLE)
  const isSuperAdminUser = roles?.includes(SUPERADMIN_ROLE)

  if (pathname.startsWith('/admin') && !isAdminUser) {
    return <Navigate to="/chat" replace />
  }
  if (pathname === '/admin/features' && !isSuperAdminUser) {
    return <Navigate to="/admin/dashboard" replace />
  }

  const features = user?.feature_flags
  const featureRouteMap = {
    '/generate/image': 'image_generation',
    '/generate/video': 'video_generation',
    '/generate/presentation': 'presentation_generation',
    '/generate/cad': 'cad_generation',
  }
  const requiredFeature = featureRouteMap[pathname]
  if (requiredFeature && !features?.includes(requiredFeature)) {
    return <Navigate to="/chat" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
